import * as types from "./types";
import { HttpClient, MHTTPCL } from "../../../../services/http/http-client";
import { LabelsService } from "../../services/labels.service";
import { getNavTabModule } from "../../../../dt-plugins/sidewindow/nav-tab";
import { setMainNavInactive } from "../../../../store/app/mutations";
import { value } from "sanctuary";
import { MODIFICATION_URL } from "../../../../services/common-urls";
import router from "../../../../router";
import { EOL_REACHED, LoadedEnd } from '../../../../dt-plugins/advanced-search/load.model';
// Action Object for LabelsCatalog. Import the types from labels/types.js and Invoke Actions from the Vuex Host Components.
const NavTabModule = getNavTabModule(types.LabelDetails, "labelDetails");

export const labelsCatalogActions = {
  async [types.LabelsCatalogData.FETCH.ALL](
    { commit, getters, dispatch },
    payload
  ) {
    const labelsCatalogData = await HttpClient.mergeRequests([]);
    console.log(labelsCatalogData);
    commit(types.LabelsCatalogData.SET.ALL, labelsCatalogData);
  },

  // Table List
  async [types.LabelList.FETCH.ALL]({ commit, getters, state }, payload) {
     console.log("payload actions ", payload);
  //   let { term, no_autofetch,status,type } = payload;
  //  if ((term && term.length > 0) || (no_autofetch === 0 || no_autofetch === 1) || status || type) {
  //     const res = await LabelsService.fetchListLabel(term, no_autofetch,status,type);
  //     const data={
  //       ...getters.labelList,
  //       labels:res.data.labels
  //     }
  //     commit(types.LabelList.SET.ALL, data);
  //   }

  //   else {
  //     const res = await LabelsService.fetchListLabel(term, no_autofetch,status,type );
  //     commit(types.LabelList.SET.ALL, res.data);
  //   }

  const { start, row_count, searchMode, basicFilter } = payload;
console.log('searchMode',searchMode)
  let res;
  if (searchMode == 'none') {
    if (start == 0) {
      res = res = await LabelsService.fetchListLabel(start);
      commit(types.LabelList.SET.ALL, { labels: res?.data?.labels });
    } else {
      res = res = res = await LabelsService.fetchListLabel(start);
      commit(types.LabelList.SET.ALL, {
        ...getters.labelList,
        labels: [
          ...getters.labelList?.labels,
          ...res.data.labels,
        ]
      });

      // Setting EOL
      if (!(res?.data?.labels?.length > 0)) {
        return EOL_REACHED;
      }
    }

  } 
  
  else if (searchMode == 'basic') {
    const { searchString, no_autofetch, royalty_status,type,label_status_ids } = basicFilter;

    res = res = await LabelsService.fetchListLabel(start,searchString, no_autofetch,royalty_status,type,label_status_ids);
    if (start == 0) {
      commit(types.LabelList.SET.ALL, {
        ...getters.labelList,
        labels: res.data.labels
      });
    } else {

      commit(types.LabelList.SET.ALL, {
        ...getters.labelList,
        labels: [
          ...getters.labelList.labels,
          ...res.data.labels
        ]
      });
    }


    // Setting EOL
    if (!(res?.data?.labels?.length > 0)) {
      return EOL_REACHED;
    }
  }
  },
  async [types.LabelList.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {

    const { itemID, colorPropertyName, colorPropertyValue, colorValue, colorName } = payload;
    console.log({ itemID, colorPropertyName, colorPropertyValue, colorValue, colorName },getters.labelList,":::::::::::::")

    const mod = await MHTTPCL.modifyJSON(undefined, itemID, colorPropertyName, colorPropertyValue, 'l_labels');



    // getters.releasesCatalogData.releases.push(releaseDetails.data.release)

    commit(types.LabelList.SET.ALL, {
      ...getters.labelList,
      labels: getters.labelList.labels.map(e => {
        if (e.label_id == itemID) {
          return {
            ...e,
            [colorName]: colorValue,
            [colorPropertyName]: colorPropertyValue
          }
        }

        return { ...e }
      }),

    });

    console.log('{ itemID, colorPropertyName, colorPropertyValue, colorValue, colorName }',getters.labelList,":::::::::::::")



  },

  // Deleted Label List
  async [types.LabelList.DELETE.SINGLE]({ commit, getters }, item) {
    const { label_id } = item;

    let newLabelList = getters.labelList.labels.filter(
      e => e.label_id != label_id
    );

    commit(types.LabelList.SET.ALL, {
      ...getters.labelList,
      labels: newLabelList
    });

    const removeLabel = await LabelsService.removeLabel(label_id);
  },

  // Show Sidewindow
  async [types.LabelDetails.FETCH.SINGLE](
    { commit, getters, dispatch },
    payload = {}
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, label, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "label_id";
    const itemName = "label";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "labelDetails";
    const DetailsAction = types.LabelDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const detailsData = await HttpClient.mergeRequests([
      LabelsService.fetchLabelDetails(label.label_id),
      LabelsService.fetchLabelDetailsTabOverview(label.label_id),
      LabelsService.labelDetailsMetadata(label.label_id),
      LabelsService.showMetadata(label.label_id),
      LabelsService.fetchLabelDetailsTabInfo(label.label_id),
      LabelsService.fetchLabelReleasesProducts(label.label_id),
      LabelsService.fetchLabelDetailsTabSetup(label.label_id)
    ]);

    console.log("detailsData", detailsData);

    // DBox
    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, label) => {
        return {
          ...label,
          ...detailsData,
          loading: false
        };
      }
    );
  },

  // Left NavItem child details
  ...NavTabModule.implementActions(
    "label_id",
    "labels/label_id/tab",
    "labels",
    () => router,
    "catalog",
    (value, key) => {
      return {
        title:
          value && value.label && value.label.label_name
            ? value.label.label_name
            : key,
        full_title:
          value && value.label && value.label.label_name
            ? value.label.label_name
            : key
      };
    }
  ),

  // MetaData
  async [types.MetaData.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, kVal } = payload;
    const { label_id } = item;

    // const labelObj = getters.labelDetails[label_id];

    const table = "metadata";

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      return {
        all_item_metadata: labelObj.all_item_metadata.map(e => {
          if (e.metadata_id == kVal) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const updatedPriceRes = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  // Related Files
  async [types.SET_LABEL_PRODUCT_FILES](
    { dispatch, getters },
    { files, externalId, externalTable }
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const label_id = externalId;
    console.log("filesss ", files);
    NavTabHelper.setSingleNavTabDetails(label_id, (_, labelDetailsObject) => {
      return {
        ...labelDetailsObject,
        files
      };
    });
  },

  // Start Artwork Logo
  async [types.SET_LABEL_ARTWORK]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { label, file, artworkKey } = payload;
    const { file_id } = file;
    const { label_id } = label;

    NavTabHelper.updateSingleNavTabDetails(label_id, _ => {
      return {
        [artworkKey]: file.file_link
      };
    });

    await MHTTPCL.modify("label_id", label_id, artworkKey, file_id, "l_labels");
  },
  // End Artwork Logo

  // Notes - Action of Updating single Object
  async [types.LabelDetails.UPDATE.SINGLE]({ dispatch, getters }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, selectedLabelDetails } = payload;
    const { label } = selectedLabelDetails;
    const { label_id } = label;

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      return {
        label: {
          ...labelObj.label,
          [name]: value
        }
      };
    });

    const table = "l_labels";

    const updatedLabelDetailsRes = await MHTTPCL.modify(
      "label_id",
      label_id,
      name,
      value,
      table
    );
    // const updatedLabelDetailsRes = await MHTTPCL.post(
    //   MODIFICATION_URL,
    //   {
    //     key: "label_id",
    //     kVal: label_id,
    //     name,
    //     value,
    //     table,
    //     modified: "2021-06-07+08:21:03",
    //     DOMid: "label_1588_isrc_base"
    //   }
    // );
  },

  // Start Related Contacts
  async [types.LabelRelatedContacts.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { name, value, item, label } = payload;
    const { label_id } = label;

    const key = "contact_relation_id";
    const kVal = item[key];
    const table = "contact_relations";

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      return {
        contact_relations: labelObj.contact_relations.map(e => {
          if (e.contact_relation_id == item.contact_relation_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedLabel = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },

  async [types.LabelRelatedContacts.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    const { contact, label } = payload;
    const { label_id } = label;
    const { contact_relation_id } = contact;

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      return {
        contact_relations: labelObj.contact_relations.filter(
          e => e.contact_relation_id != contact_relation_id
        )
      };
    });

    const deletedContact = await LabelsService.deleteContactRelation(
      contact_relation_id
    );
  },

  async [types.LabelRelatedContacts.SET.ALL](
    { commit, getters, dispatch },
    { contact_relations, external_table, external_id }
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(
      external_id,
      (_, labelDetailsObject) => {
        return {
          ...labelDetailsObject,
          contact_relations: contact_relations
        };
      }
    );
  },
  // End Related Contacts

  // Start Action of Updating single Object -- Setup
  async [types.LabelAccountsSetup.UPDATE.SINGLE](
    { getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    console.log("Setup - Actions payload ", payload);

    const { name, value, item, selectedLabelDetails } = payload;
    const { label_id } = selectedLabelDetails;

    const key = "label_account_id";
    const kVal = item[key];
    const table = "l_label_accounts";

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      // labelObj --> getters.labelDetails
      // console.log('labelObj ', labelObj);
      return {
        label_accounts: labelObj.label_accounts.map(e => {
          if (e.label_account_id == item.label_account_id) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      };
    });

    const modifiedLabel = await MHTTPCL.modifyJSON(
      undefined,
      kVal,
      name,
      value,
      table
    );
  },
  // End Setup

  // Start Label Accounts Deleted - Setup
  async [types.LabelAccountsSetup.DELETE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("Setup Deleted - Actions payload ", payload);

    const { label_id, label_account_id } = payload;

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      return {
        label_accounts: labelObj.label_accounts.filter(
          e => e.label_account_id != label_account_id
        )
      };
    });

    await LabelsService.deleteLabelAccount(label_account_id);
  },
  // End Label Accounts Deleted - Setup

  // Start Label Accounts SearchList - Setup
  async [types.LabelAccountsSetup.SET.ALL]({ getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    console.log("Search List Label - Actions payload ", payload);
    const { label_accounts, selectedLabelDetails } = payload;
    const { label_id } = selectedLabelDetails;

    NavTabHelper.updateSingleNavTabDetails(label_id, labelObj => {
      return {
        label_accounts
      };
    });
  }
};
